export const penIcon = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.9214 3.5125C21.6007 3.19181 21.22 2.93743 20.801 2.76387C20.382 2.59032 19.933 2.50099 19.4794 2.50099C19.0259 2.50099 18.5768 2.59032 18.1578 2.76387C17.7388 2.93743 17.3581 3.19181 17.0374 3.5125L4.95343 15.5985C4.57238 15.9793 4.30087 16.4556 4.16743 16.9775L2.95393 21.72C2.92716 21.8251 2.92817 21.9353 2.95687 22.0398C2.98557 22.1444 3.04097 22.2396 3.11763 22.3163C3.19429 22.393 3.28957 22.4484 3.39412 22.4771C3.49866 22.5058 3.60888 22.5068 3.71393 22.48L8.45743 21.268C8.97969 21.1347 9.45639 20.8632 9.83743 20.482L21.9214 8.396C22.5689 7.74836 22.9327 6.87006 22.9327 5.95425C22.9327 5.03845 22.5689 4.16014 21.9214 3.5125ZM17.9214 4.3965C18.3346 3.98323 18.8951 3.75103 19.4795 3.75098C20.0639 3.75093 20.6244 3.98304 21.0377 4.39625C21.451 4.80946 21.6832 5.36991 21.6832 5.95432C21.6833 6.53873 21.4511 7.09923 21.0379 7.5125L19.9344 8.616L16.8184 5.4995L17.9214 4.3965ZM15.9344 6.3835L19.0504 9.5L8.95343 19.598C8.73108 19.8206 8.45281 19.9792 8.14793 20.057L4.42643 21.008L5.37843 17.2875C5.45643 16.9825 5.61493 16.7045 5.83693 16.4825L15.9344 6.3835Z"
      fill="currentColor"
    />
  </svg>
);

export const fileIcon = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4346 18H13.4346V15H16.4346V14H13.4346V11H12.4346V14H9.43457V15H12.4346V18ZM5.93457 21.5V3.5H15.4346L19.9346 8V21.5H5.93457ZM14.9346 8.5V4.5H6.93457V20.5H18.9346V8.5H14.9346Z"
      fill="currentColor"
    />
  </svg>
);

export const flagIcon = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.93457 13.5V20.5C7.93457 20.642 7.88657 20.7607 7.79057 20.856C7.69457 20.9513 7.57557 20.9993 7.43357 21C7.29157 21.0007 7.1729 20.9527 7.07757 20.856C6.98224 20.7593 6.93457 20.6407 6.93457 20.5V6.308C6.93457 6.07933 7.0119 5.88733 7.16657 5.732C7.32124 5.57666 7.51324 5.49933 7.74257 5.5H13.4556C13.6489 5.5 13.8216 5.559 13.9736 5.677C14.1256 5.795 14.2202 5.95166 14.2576 6.147L14.5276 7.5H19.1276C19.3562 7.5 19.5479 7.57666 19.7026 7.73C19.8572 7.88333 19.9346 8.07333 19.9346 8.3V14.7C19.9346 14.9267 19.8572 15.1167 19.7026 15.27C19.5479 15.4233 19.3559 15.5 19.1266 15.5H15.4146C15.2212 15.5 15.0486 15.441 14.8966 15.323C14.7446 15.205 14.6499 15.0483 14.6126 14.853L14.3416 13.5H7.93457ZM15.5846 14.5H18.9346V8.5H14.3556C14.1622 8.5 13.9896 8.441 13.8376 8.323C13.6856 8.205 13.5909 8.04833 13.5536 7.853L13.2846 6.5H7.93457V12.5H14.5136C14.7069 12.5 14.8796 12.559 15.0316 12.677C15.1836 12.795 15.2782 12.9517 15.3156 13.147L15.5846 14.5Z"
      fill="currentColor"
    />
  </svg>
);

export const chatIcon = (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.62207 2.375H18.2471V13.0625H9.93457L5.18457 17.2188V13.0625H1.62207V2.375Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
